export const washOptions = {
    method: [
        { value: 'hand', label: '손세탁', icon: 'https://d1vb419ubgm46b.cloudfront.net/wash/hand_wash_1.png' },
        { value: 'machine', label: '기계 세탁', icon: 'https://d1vb419ubgm46b.cloudfront.net/wash/machine_wash.png' },
        { value: 'dry', label: '드라이클리닝', icon: 'https://d1vb419ubgm46b.cloudfront.net/wash/dry_cleaning.png' },
        { value: 'forbid', label: '세탁 불가', icon: 'https://d1vb419ubgm46b.cloudfront.net/wash/do_not_wash.png' },
    ],
    dry: [
        { value: 'natural', label: '자연 건조', icon: 'https://d1vb419ubgm46b.cloudfront.net/wash/line_dry.png' },
        { value: 'shade', label: '그늘 건조', icon: 'https://d1vb419ubgm46b.cloudfront.net/wash/dry_in_shade.png' },
        { value: 'dryer', label: '건조기 사용', icon: 'https://d1vb419ubgm46b.cloudfront.net/wash/tumble_dry.png' },
        {
            value: 'dryerforbid',
            label: '건조기 금지',
            icon: 'https://d1vb419ubgm46b.cloudfront.net/wash/no_tumble_dry.png',
        },
    ],
    iron: [
        {
            value: 'allow',
            label: '다림질 허용',
            icon: 'https://d1vb419ubgm46b.cloudfront.net/wash/ironing_allowed.png',
        },
        {
            value: 'steam',
            label: '스팀 다림질 허용',
            icon: 'https://d1vb419ubgm46b.cloudfront.net/wash/steam_ironing_allowed.png',
        },
        { value: 'forbid', label: '다림질 금지', icon: 'https://d1vb419ubgm46b.cloudfront.net/wash/do_not_iron.png' },
        {
            value: 'lowtemp',
            label: '천대고다림질',
            icon: 'https://d1vb419ubgm46b.cloudfront.net/wash/low_temp_ironing.png',
        },
    ],
    bleach: [
        { value: 'allow', label: '표백 가능', icon: 'https://d1vb419ubgm46b.cloudfront.net/wash/bleach_allowed.png' },
        { value: 'cl', label: '염소계 표백 가능', icon: 'https://d1vb419ubgm46b.cloudfront.net/wash/cl.png' },
        { value: 'forbid', label: '표백 금지', icon: 'https://d1vb419ubgm46b.cloudfront.net/wash/do_not_bleach.png' },
    ],
    special: [
        { value: 'mild', label: '약하게 세탁', icon: 'https://d1vb419ubgm46b.cloudfront.net/wash/gentle_wash.png' },
        {
            value: 'verymild',
            label: '매우 약하게 세탁',
            icon: 'https://d1vb419ubgm46b.cloudfront.net/wash/very_gentle_wash.png',
        },
        { value: 'alone', label: '단독 세탁', icon: 'https://d1vb419ubgm46b.cloudfront.net/wash/wash_separately.png' },
        {
            value: 'twistforbid',
            label: '비틀기 금지',
            icon: 'https://d1vb419ubgm46b.cloudfront.net/wash/do_not_wring.png',
        },
        {
            value: 'alonehand',
            label: '단독손세탁',
            icon: 'https://d1vb419ubgm46b.cloudfront.net/wash/wash_separately_hand.png',
        },
    ],
    detergent: [
        {
            value: 'dedicated',
            label: '전용세제',
            icon: 'https://d1vb419ubgm46b.cloudfront.net/wash/dedicated_detergent.png',
        },
        {
            value: 'neutral',
            label: '중성세제',
            icon: 'https://d1vb419ubgm46b.cloudfront.net/wash/neutral_detergent.png',
        },
    ],
};

// 레거시 값 변환 매핑 (이전 값 -> 새로운 값)
export const washValueMapping: Record<string, { category: keyof typeof washOptions; value: string }> = {
    약하게: { category: 'special', value: 'mild' },
    표백금지: { category: 'bleach', value: 'forbid' },
    그늘에건조: { category: 'dry', value: 'shade' },
    비틀기금지: { category: 'special', value: 'twistforbid' },
    기계세탁가능: { category: 'method', value: 'machine' },
    단독손세탁: { category: 'special', value: 'alonehand' },
    중성세제: { category: 'detergent', value: 'neutral' },
    천대고다림질: { category: 'iron', value: 'lowtemp' },
};

// washInfo 값을 변환하는 함수
export const normalizeWashValue = (value: string): { category: keyof typeof washOptions; value: string } | null => {
    // 먼저 매핑된 값이 있는지 확인
    if (washValueMapping[value]) {
        return washValueMapping[value];
    }

    // 이미 정규화된 값이라면 카테고리를 찾아서 반환
    for (const [category, options] of Object.entries(washOptions)) {
        const option = options.find((opt) => opt.value === value);
        if (option) {
            return { category: category as keyof typeof washOptions, value };
        }
    }

    return null;
};
